module.exports = __webpack_public_path__ + "static/media/icon-webdesign.15536912.svg";